import React from 'react';
import '../../styles/RateCard.css';

const MicrositesWeb = () => {
    return (
        <section className="microsites-web-section py-5" id='contenido'>
            <div className="container">
                <div className="row gx-5 align-items-center">

                    {/* Columna Izquierda */}
                    <div className="col-md-6 bg-dark-teal text-white p-5 rounded-start" data-aos="fade-right" data-aos-delay="200">
                        <h2 className="title text-white text-capitalize">
                            Micrositios<br /><span className="highlight-bg">Web</span>
                        </h2>
                        <p className="mt-4">
                            Creamos micrositios temáticos diseñados para profundizar en temas específicos y
                            campañas de concienciación, ofreciendo una experiencia exclusiva y de alto valor
                            para las marcas. Estos espacios personalizados están integrados en la red de BeHealth
                            y se potencian con nuestro tráfico orgánico y estrategias publicitarias. Con contenido
                            relevante, atractivo y optimizado, logramos captar la atención de audiencias interesadas,
                            generando un impacto duradero.
                        </p>
                        <ul className="mt-4 custom-bullets">
                            <li>Diseño y contenido alineados con los objetivos y necesidades de tu marca.</li>
                            <li>Galerías, infografías y cápsulas educativas que refuerzan el mensaje.</li>
                            <li>Integración en la red BeHealth para maximizar el tráfico orgánico y promocional.</li>
                            <li>Presencia destacada en la web durante el tiempo acordado para visibilidad sostenida.</li>
                            <li>Alcance garantizado a audiencias relevantes interesadas en la temática.</li>
                        </ul>
                        <div className="tab-label mt-4">Desarrollo Ad Hoc + Contenido</div>
                    </div>

                    {/* Columna Derecha */}
                    <div className="col-md-6 bg-light-green p-5 rounded-end position-relative" data-aos="fade-left" data-aos-delay="200">

                        <div className='d-flex justify-content-center'>
                            <div className='position-relative z-0'>
                                <h3 className="subtitle-rate-card fw-bold text-center">Características</h3>

                                <div className='position-absolute top-100 start-50 translate-middle'>
                                    <svg width="2em" height="2em" viewBox="0 0 16 16" class="position-absolute top-100 start-50 translate-middle bi bi-caret-down-fill" fill="#439b6b" xmlns="http://www.w3.org/2000/svg"><path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" /></svg>
                                </div>
                            </div>
                        </div>
                        <div className='reach mt-3 rounded p-3'>
                            <h4>Audiencia:</h4>
                            <p className="">
                                Micrositios con una audiencia segmentada que garantiza visitas orgánicas y promocionadas de calidad.
                            </p>

                            <h4>Permanencia:</h4>
                            <p className="">
                                Los micrositios están disponibles x 1 año con opción a renovación.
                            </p>
                        </div>
                        <div className="includes-box">
                            <div className='shadow-lg rounded p-4 mt-3'>
                                <h5 className="fw-bold text-teal">Incluye:</h5>
                                <ul className="ps-3 mt-2">
                                    <li>Artículos contextuales en BeHealth con galerías y cápsulas educativas.</li>
                                    <li>Espacios exclusivos para publicidad de la marca y/o productos relacionados del mismo anunciante.</li>
                                    <li>Paid Media en públicos exclusivos para más tráfico e interacción.</li>
                                </ul>
                            </div>
                        </div>

                        <div className='w-100 d-flex justify-content-center'>
                            <div className="investment-box bg-teal text-white p-3 mt-4 rounded shadow-lg">
                                <strong>Inversión:</strong><br />
                                A cotizar inversión mensual micrositio disponible por un año.
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default MicrositesWeb;
